import { useState, useCallback } from 'react';

export const useToggle = (defaultValue = false) => {
    const [toggle, setToggle] = useState(defaultValue);

    const handleToggle = useCallback(() => {
        setToggle((oldStateToggle) => !oldStateToggle);
    }, [setToggle]);

    return [toggle, handleToggle];
};
